// Takvim açılır penceresinde ay ve gün adları dile göre (dayjs; ADR 0033). Türkçe yerel ayar bir
// kez yüklenir; İngilizce dayjs'in varsayılanıdır.
import 'dayjs/locale/tr.js';
import { useTranslation } from 'react-i18next';

/** Tarih girişlerinin ortak dili ve erişilebilir adları (i18next `common`). */
export function useDatesLabels() {
  const { t, i18n } = useTranslation();
  return {
    locale: i18n.resolvedLanguage === 'tr' ? 'tr' : 'en',
    previousLabel: t('common.previousMonth'),
    nextLabel: t('common.nextMonth'),
    hoursInputLabel: t('common.hours'),
    minutesInputLabel: t('common.minutes'),
    datePlaceholder: t('common.datePlaceholder'),
    clearDate: t('common.clearDate'),
    dateTimePlaceholder: t('common.dateTimePlaceholder'),
    apply: t('common.apply'),
  };
}
